import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

import { getImageUrl } from '@/lib/polaroid-utils';

function isValidPicture(event: NostrEvent): boolean {
  if (event.kind !== 20) return false;
  return !!getImageUrl(event);
}

/** Query kind 20 picture events by a specific author. */
export function useUserPictures(pubkey: string | undefined, limit = 50) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['pictures', 'user', pubkey ?? '', limit],
    queryFn: async () => {
      if (!pubkey) return [];
      const events = await nostr.query(
        [{ kinds: [20], authors: [pubkey], limit: limit + 10 }],
        { signal: AbortSignal.timeout(5000) },
      );
      return events.filter(isValidPicture).slice(0, limit);
    },
    enabled: !!pubkey,
    staleTime: 60 * 1000,
  });
}
